<script lang="ts">
	import decorationFooter from "@assets/images/deco/decoration - footer.svg";
	import decorationMenu from "@assets/images/deco/decoration - menu.svg";
	import decorationRounded from "@assets/images/deco/decoration - rounded.svg";
	import decorationVertical1 from "@assets/images/deco/decoration - vertical-1.svg";
	import decorationVertical from "@assets/images/deco/decoration - vertical.svg";
	import type { DecorationType } from "./pageDecorations.js";

	const {
		decoration = "none",
	}: {
		decoration?: DecorationType;
	} = $props();

	const decorationMap = {
		vertical: decorationVertical,
		"vertical-1": decorationVertical1,
		rounded: decorationRounded,
		menu: decorationMenu,
		footer: decorationFooter,
		none: null,
	} as const;

	const decorationImage = $derived(decorationMap[decoration]);
</script>

{#if decorationImage}
	{#if decoration === "rounded"}
		<div class="pointer-events-none md:block hidden fixed inset-0 -z-10 overflow-x-clip">
			<div class="absolute top-0 left-1/2 -translate-x-1/2 w-[145vw] h-[145vh]">
				<img src={decorationImage} alt="Dekorativní prvek stránky" class="w-full h-full object-cover" />
			</div>
		</div>
	{:else}
		<img
			src={decorationImage}
			alt="Dekorativní prvek stránky"
			class="pointer-events-none container-center md:block hidden absolute left-0 right-0 sm:left-1/2 -translate-x-1/2 top-[5rem] max-w-[2100px] -z-10 h-auto sm:w-[calc(100%-5rem)] w-full object-cover"
		/>
	{/if}
{/if}
